import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {ToastrService} from "ngx-toastr";

@Directive({
  standalone: true,
  selector: '[appCopy]',
})
export class CopyDirective {
  @Input() appCopy = '';
  @Input() text: string;

  constructor(private el: ElementRef, private toastr: ToastrService) {
  }

  @HostListener('click') onClick() {
    if(this.text) {
      this.copy(this.text, this.appCopy);
    } else {
      this.copy(this.el.nativeElement.textContent, this.appCopy);
    }
  }

  copy(str: string, type: string): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (str.trim()));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    this.toastr.success(type + ' copié dans le presse-papier');
  }
}
